/**
 * @author Ahmed Samer
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2019-06-17
 * @description Implementation of the GraphQL mutation to update a media asset.
 * @filename update-media-asset-file
 */
import { graphql, GraphQLTaggedNode } from "react-relay";

/**
 * The GraphQL mutation to update a media asset file.
 *
 * @type {GraphQLTaggedNode}
 */
export const UPDATE_MEDIA_ASSET_FILE_GRAPHQL_MUTATION: GraphQLTaggedNode = graphql`
  mutation updateMediaAssetFileMutation($input: UpdateMediaAssetFileInput!) {
    updateMediaAssetFile(input: $input) {
      clientMutationId
      hasErrors
      errors {
        id
        location
      }
      mediaAssetFile {
        id
        name
        copies {
          id
        }
      }
    }
  }
`;
